__turbopack_context__.v({
  "contact_form_content": "ecl9kG_contact_form_content",
  "infoBox": "ecl9kG_infoBox",
});
